// What the user is giving feedback on, derived from the URL + document title, so
// a report is always attributed to the exact template/tool/guide/resource without
// per-page wiring. (HelpChat's richer session context lives in pageContext.ts.)

const TYPE_BY_PREFIX: Record<string, string> = {
  templates: "template",
  tools: "tool",
  guides: "guide",
  assets: "resource",
  resources: "resource",
};

export type FeedbackContext = { resourceType: string; slug: string; title: string };

/**
 * Resolve the current page's content type, slug and human title.
 * Pass `overrideType` when the mount already knows the section (e.g. ToolShell
 * passes "tool"); otherwise it's inferred from the first path segment.
 */
export function deriveContext(overrideType?: string): FeedbackContext {
  if (typeof window === "undefined") {
    return { resourceType: overrideType || "page", slug: "", title: "" };
  }
  const path = window.location.pathname.replace(/\/+$/, "");
  const seg = path.split("/").filter(Boolean);
  let resourceType = overrideType || "page";
  let slug = path || "/";
  if (seg.length >= 1 && TYPE_BY_PREFIX[seg[0]]) {
    if (!overrideType) resourceType = TYPE_BY_PREFIX[seg[0]];
    slug = seg[1] || seg[0];
  }
  // Page titles are "<thing> — RamsDocs" / "<thing> | RamsDocs"; keep the <thing>.
  const title = (document.title || "").replace(/\s*[—|].*$/, "").trim() || slug;
  return { resourceType, slug, title };
}
